export const CHECKOUT_BASE = 'https://www.valux.site/cart/51619109634354:1'
export const CHECKOUT_COMPLETO = 'https://www.valux.site/cart/51619110715698:1'

export const MOCKUP_IMAGE =
  'https://cdn.magicpatterns.com/uploads/ok5gHyGxK856ZQsSe62MtW/Mockup_v3_Landing_PNG_600x600_Sin_Fondo_OK_WEBP.webp'

export const heroBadges = [
  '📄 100% Digital PDF',
  '⚡ Acceso en 5 min',
  '📲 WhatsApp + Instagram',
]

export const heroTrust = ['🛡️ Garantía 7 días', '🔒 Pago seguro', '💳 Mercado Pago']

export const stats = [
  { value: '+400', label: 'Comerciantes activos' },
  { value: '2', label: 'Tomos completos' },
  { value: '10', label: 'Bonos incluidos' },
  { value: '4.9 ★', label: 'Calificación' },
]

export const heroTestimonials = [
  {
    initials: 'MG',
    quote:
      '"Apliqué el Método de las 72 Horas y liquidé gorras, riñoneras y gorros de lana que me habían quedado clavados de la temporada pasada. Solo con eso ya pagué el sistema tres veces."',
    author: '— Marcela G. · Córdoba',
  },
  {
    initials: 'LP',
    quote:
      '"Los textos de WhatsApp los copié tal cual y empecé a cerrar ventas que antes se me escapaban. El del \'vuelvo después\' me funcionó desde el primer día."',
    author: '— Luis P. · Rosario',
  },
  {
    initials: 'RM',
    quote:
      '"Mi Instagram era un cementerio. Seguí el checklist del Sistema y en tres semanas empezaron a llegar consultas todos los días. Sin pagar publicidad."',
    author: '— Roberto M. · CABA',
  },
]

export const painPoints = [
  'Mercadería clavada en la estantería que se devalúa con la inflación.',
  'Subís estados a WhatsApp y fotos a Instagram que nadie mira.',
  'El cliente pregunta, regatea por centavos, dice "vuelvo después" y desaparece.',
  'Comprás al mayorista con urgencia y sin comparar regalando el margen.',
]

export const volumes = [
  {
    icon: '📘',
    title: 'Tomo 1 — SISTEMA STOCK CERO BASE',
    description:
      'El sistema para vender lo que ya tenés, cobrar lo que vale y que el cliente vuelva siempre.',
    items: [
      'Ganarle al Mayorista',
      'La Llave del WhatsApp™',
      'El Método de las 72 Horas',
      'Instagram: Local Abierto',
      'Calendario de contenidos',
    ],
  },
  {
    icon: '📗',
    title: 'Tomo 2 — TRÁFICO DE LA CALLE',
    description: 'El sistema para traer clientes nuevos todos los meses.',
    items: [
      'Mapa Maestro: Traer Gente Nueva',
      'Anuncios que cortan la calle',
      'El cliente nuevo se queda',
      'Comprar más barato en Once, Flores y La Salada',
    ],
  },
]

export const bonuses = [
  { number: '01', title: 'CUENTA-MONEDAS' },
  { number: '02', title: 'EL TEXTO QUE TRAE PLATA' },
  { number: '03', title: 'INSTAGRAM: LOCAL ABIERTO' },
  { number: '04', title: 'CALENDARIO: QUÉ SUBIR HOY' },
  { number: '05', title: 'TRUCO: VACIAR ESTANTERÍAS' },
  { number: '06', title: 'MANUAL: VENCER EL "ESTÁ CARO"' },
  { number: '07', title: 'LISTA: CLIENTES QUE VUELVEN' },
  { number: '08', title: 'TRUCO: SACARSE LOS CLAVOS' },
  { number: '09', title: 'GUÍA: COMPRAR MÁS BARATO' },
  { number: '10', title: 'ANUNCIOS: CORTAR LA CALLE' },
]

export const plans = [
  {
    icon: '📘',
    name: 'SISTEMA STOCK CERO BASE',
    includes: '1 Tomo + 5 Bonos',
    idealFor: 'Vaciar stock y vender más.',
    oldPrice: '$87.000',
    price: '$19.990 ARS',
    cta: '📦 QUIERO MI SISTEMA STOCK CERO™ →',
    href: CHECKOUT_BASE,
    featured: false,
  },
  {
    icon: '🏆',
    name: 'SISTEMA STOCK CERO COMPLETO ⭐',
    includes: '2 Tomos + 10 Bonos',
    idealFor: 'Crecer y traer gente nueva.',
    oldPrice: '$164.000',
    price: '$27.990 ARS',
    cta: '→ QUIERO EL SISTEMA COMPLETO',
    href: CHECKOUT_COMPLETO,
    featured: true,
  },
]

export const upsellRows = [
  {
    situation: 'No sabés de dónde vendrán los clientes',
    without: 'Dependés del boca a boca',
    with: 'Mapa Maestro',
  },
  {
    situation: 'Querés publicidad pero no sabés cómo',
    without: 'Sin sistema de anuncios',
    with: 'Meta Ads paso a paso',
  },
  {
    situation: 'Un cliente compró pero no volvió',
    without: 'Sin sistema de retención',
    with: 'Mensaje 48 horas',
  },
  {
    situation: 'El cliente dice "está caro"',
    without: 'Sin herramienta',
    with: 'Manual 5 métodos',
  },
  {
    situation: 'Comprás siempre en el mismo mayorista',
    without: 'Pagás precio de urgencia',
    with: 'Guía para negociar',
  },
]

export const testimonials = [
  {
    initials: 'CR',
    name: 'Cecilia R.',
    quote: '"Publico todos los días en 10 minutos y me llegan consultas."',
  },
  {
    initials: 'SC',
    name: 'Santiago C.',
    quote: '"Ajusté los precios y el margen mejoró."',
  },
  {
    initials: 'PA',
    name: 'Paula A.',
    quote: '"Los anuncios me trajeron 18 clientes nuevos el primer mes."',
  },
  {
    initials: 'VL',
    name: 'Valeria L.',
    quote: '"Mandé el mensaje y en 24 horas vendí 4 prendas paradas."',
  },
  {
    initials: 'DM',
    name: 'Diego M.',
    quote: '"La guía me ahorró el 15% en Once."',
  },
  {
    initials: 'NR',
    name: 'Nicolás R.',
    quote: '"El 44% de mis clientes nuevos volvió a comprar."',
  },
]

export const faqs = [
  {
    question: '¿Sirve para cualquier tipo de comercio?',
    answer:
      'Sí, para cualquier rubro con reventa de productos (ropa, bazar, ferretería).',
  },
  {
    question: '¿Cómo recibo el material?',
    answer: 'Acceso inmediato al PDF por email tras el pago.',
  },
  {
    question: '¿Necesito saber de marketing?',
    answer: 'No. Todo es copiar y pegar.',
  },
]

export const costRows = [
  { without: '1 producto clavado', cost: 'Capital muerto que se devalúa' },
  { without: 'WhatsApp sin textos', cost: 'Ventas perdidas por semana' },
  { without: 'Instagram sin sistema', cost: 'Horas tiradas sin consultas' },
  {
    without: 'Compra con urgencia',
    cost: '10% a 20% más caro por operación',
  },
]

export const footerTrust = [
  '🔒 Pago 100% seguro',
  '⚡ Acceso en 5 min',
  '🛡️ Garantía 7 días',
  '💳 Mercado Pago',
]

export const footerLinks = [
  {
    icon: '📧',
    label: 'soporte.valux@gmail.com',
    href: 'mailto:soporte.valux@gmail.com',
  },
  {
    icon: '📲',
    label: '@valux.oficial',
    href: 'https://instagram.com/valux.oficial',
  },
  { icon: '🌐', label: 'www.valux.site', href: 'https://www.valux.site' },
]

export const liveNotifications = [
  {
    name: 'Gabriela O.',
    city: 'Tucumán',
    product: 'Sistema Stock Cero™ Completo 🏆',
    time: 'hace 8 minutos',
  },
  {
    name: 'Martín R.',
    city: 'Córdoba',
    product: 'Sistema Stock Cero™ Base 📘',
    time: 'hace 14 minutos',
  },
  {
    name: 'Valeria S.',
    city: 'Rosario',
    product: 'Sistema Stock Cero™ Completo 🏆',
    time: 'hace 21 minutos',
  },
  {
    name: 'Diego F.',
    city: 'CABA',
    product: 'Sistema Stock Cero™ Base 📘',
    time: 'hace 33 minutos',
  },
  {
    name: 'Cecilia M.',
    city: 'Mendoza',
    product: 'Sistema Stock Cero™ Completo 🏆',
    time: 'hace 47 minutos',
  },
  {
    name: 'Pablo T.',
    city: 'GBA',
    product: 'Sistema Stock Cero™ Base 📘',
    time: 'hace 52 minutos',
  },
  {
    name: 'Romina V.',
    city: 'Tucumán',
    product: 'Sistema Stock Cero™ Completo 🏆',
    time: 'hace 1 hora',
  },
]
